export default __webpack_public_path__ + "static/media/sy-dp2.035c0cd9.png";